import { createAction } from '@ngrx/store';

const UpdateListOrGrid = createAction('[documents] UpdateListOrGrid ');

export const DocumentsActions = {
  UpdateListOrGrid,
};
